import { css } from "@emotion/core";
import { fontSizes, fonts, color } from "../../../theme/Theme";

export const UploadBillStyles = css({
  ".label": {
    marginTop: "1.25rem"
  },
  ".anticon-close": {
    display: "flex",
    alignItems: "center"
  },
  ".ant-upload": {
    fontSize: fontSizes.label
  },
  ".upload-icon": {
    cursor: "pointer"
  },
  ".title": {
    fontSize: fontSizes.title,
    fontFamily: fonts.bold,
    color: color.secondary
  },
  ".file-list-container": {
    height: "2.75rem",
    borderBottom: "1px solid " + color.border
  }
});
